import React from 'react';
import PropTypes from 'prop-types';
import { ROUNDED_SHAPE } from '@loggi/ui/components/button/types';
import View from '@loggi/ui/components/view';
import Col from '@loggi/ui/components/col';
import Button from '@loggi/ui/components/button';
import {
  CONFIRM_DELIVERY_BUTTON_TEXT,
  DENY_DELIVERY_BUTTON_TEXT
} from './confirm-delivery.constants';

export default function ConfirmDeliveryButton({
  onClickToDeny,
  onClickToConfirm,
  isDisabled
}) {
  return (
    <View>
      <Col
        flex
        flexDirection="column"
        gutter={{
          bottom: 'normal',
          left: 'double',
          right: 'double'
        }}
      >
        <Button
          shape={ROUNDED_SHAPE}
          style="outline"
          value={DENY_DELIVERY_BUTTON_TEXT}
          onClick={onClickToDeny}
          disabled={isDisabled}
        />
      </Col>
      <Col
        flex
        flexDirection="column"
        gutter={{
          left: 'double',
          right: 'double',
          bottom: 'triple'
        }}
      >
        <Button
          shape={ROUNDED_SHAPE}
          style="outline"
          value={CONFIRM_DELIVERY_BUTTON_TEXT}
          onClick={onClickToConfirm}
          disabled={isDisabled}
        />
      </Col>
    </View>
  );
}

ConfirmDeliveryButton.displayName = 'ConfirmDeliveryButton';

ConfirmDeliveryButton.propTypes = {
  onClickToDeny: PropTypes.func.isRequired,
  onClickToConfirm: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired
};
